import { useT } from "@/i18n"

/**
 * The method/credibility beat (PromptJuggler's "craftsmanship" slot): a
 * bordered, centred panel that names the Holigral method and Pam Saunders.
 */
export default function Closing() {
  const { t } = useT("content")

  return (
    <section className="mx-auto max-w-2xl px-6 pt-8 pb-12 sm:pt-12 sm:pb-20">
      <div className="border-y border-border py-12 text-center sm:py-16">
        <h2 className="text-2xl font-normal tracking-tight text-balance sm:text-3xl">
          {t("home.closing.title")}
        </h2>
        <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-muted-foreground sm:text-lg">
          {t("home.closing.body")}
        </p>
        <p className="mt-6 text-sm text-muted-foreground italic">
          {t("home.closing.attribution")}
        </p>
      </div>
    </section>
  )
}
